import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  cancelShare,
  shareCancelled,
} from 'src/app/core/actions/object.actions';
import { DataObject } from 'src/app/core/models/core.models';
import { AppState } from 'src/app/reducers';

@Component({
    selector: 'app-export-status',
    templateUrl: './export-status.component.html',
    styleUrls: ['./export-status.component.scss'],
    standalone: false
})
export class ExportStatusComponent implements OnInit {
  @Input() exportObject: DataObject;
  cancelAction() {
    this.store.dispatch(
      cancelShare({
        objectId: this.exportObject.id,
      }),
    );
  }

  constructor(protected store: Store<AppState>) {
    this.exportObject = {} as DataObject;
  }

  ngOnInit() {}

  cancel() {
    this.cancelAction();
  }
}
